import { Alert, Typography } from '@faceup/ui-base'
import type { AiPromptName } from '@faceup/utils'
import { getAiPromptConfig, hasAiPromptPreview } from './aiPromptDefinitions'

const { Text } = Typography

type AiPromptPlaceholderGuideProps = {
  name: AiPromptName
}

export const AiPromptPlaceholderGuide = ({ name }: AiPromptPlaceholderGuideProps) => {
  if (!hasAiPromptPreview(name)) {
    return null
  }

  const { variables, conditions } = getAiPromptConfig(name)
  const conditionBlocks = Object.values(conditions).flatMap(({ description, blocks }) =>
    Object.entries(blocks).map(([block, keepWhen]) => ({ block, description, keepWhen }))
  )

  return (
    <Alert
      type='info'
      message='Prompt guide'
      description={
        <div>
          {Object.keys(variables).length > 0 && (
            <>
              <Text strong>Variables:</Text>
              <ul>
                {Object.entries(variables).map(([key, { description }]) => (
                  <li key={key}>
                    <Text code>{`{${key}}`}</Text> - {description}
                  </li>
                ))}
              </ul>
            </>
          )}
          {conditionBlocks.length > 0 && (
            <>
              <Text strong>Conditional blocks:</Text>
              <ul>
                {conditionBlocks.map(({ block, description, keepWhen }) => (
                  <li key={block}>
                    <Text code>{`<!-- IF_${block} -->`}</Text> ...{' '}
                    <Text code>{`<!-- END_IF_${block} -->`}</Text> - kept when "{description}" is{' '}
                    {keepWhen ? 'on' : 'off'}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      }
    />
  )
}
